/**
 * Formats a number into a short string representation with K/M suffixes
 * @param value - The number to format
 * @returns A string representation of the number with appropriate suffix
 * @example
 * formatShortNumber(1500) // "1.5K"
 * formatShortNumber(1500000) // "1.5M"
 * formatShortNumber(500) // "500"
 */
export const formatShortNumber = (value: number | undefined | null): string => {
  if (typeof value !== 'number' || isNaN(value)) return '0';
  if (value >= 1000000) {
    return `${(value / 1000000).toFixed(1)}M`;
  }
  if (value >= 1000) {
    return `${(value / 1000).toFixed(1)}K`;
  }
  return value.toString();
};
